import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import es from './locales/es.json'
import fr from './locales/fr.json'
import ptBr from './locales/pt-br.json'
import ro from './locales/ro.json'

const localeMap: Record<string, { lng: string; translations: typeof fr }> = {
  fr: { lng: 'fr', translations: fr },
  br: { lng: 'pt-br', translations: ptBr },
  ro: { lng: 'ro', translations: ro },
  sp: { lng: 'es', translations: es },
}

const emptyValueFallback = {
  type: 'postProcessor' as const,
  name: 'emptyValueFallback',
  process: (value: string, key: string) => (value === '' ? key : value),
}

// __LANG__ is replaced at build time by Vite define; import.meta.env.VITE_LANG works in dev server
function getLang(): string {
  if (typeof __LANG__ === 'string' && __LANG__) return __LANG__
  if (import.meta.env.VITE_LANG) return import.meta.env.VITE_LANG
  return 'fr'
}

const viteLang = getLang()
const { lng, translations } = localeMap[viteLang] ?? localeMap['fr']

const resources: Record<string, { translation: typeof fr }> = {
  [lng]: { translation: translations },
}

// Always include French as fallback
if (lng !== 'fr') {
  resources['fr'] = { translation: fr }
}

i18n
  .use(emptyValueFallback)
  .use(initReactI18next)
  .init({
    resources,
    lng,
    fallbackLng: 'fr',
    initImmediate: false,
    load: 'currentOnly',
    cleanCode: true,
    lowerCaseLng: true,
    interpolation: {
      escapeValue: false,
    },
    postProcess: ['emptyValueFallback'],
  })

export { default } from 'i18next'
